import React, { Component } from 'react';
import pauseSvg from './pause.svg'
import playSvg from './play.svg'
import './css/playPause.css';

class PlayPause extends Component {
    render() {
      const svg = this.props.isPaused ? playSvg : pauseSvg
      return <img 
        src={svg} 
        className="Play-pause-button" alt="pause"
        height = "30"
        onClick = {this.props.onClick}
        />
    }
}

export default PlayPause;



// WEBPACK FOOTER //
// ./src/components/playPause.js